import dataLayer from 'assets/core/js/module/dataLayer'

type accommodations = Record<number, Record<string, object>>
type offers = Record<number, Record<string, object>>

export default function (resultsSelector: string): void {
  // Results appears with Ajax, we register just in case
  addDataLayerPushForElementVisible(document.querySelectorAll(resultsSelector))

  const observer = new MutationObserver((mutationList) => {
    const results: Element[] = []
    mutationList.forEach((mutationRecord) => {
      mutationRecord.addedNodes.forEach((el) => {
        if (el instanceof HTMLElement) {
          const els = el.querySelectorAll(resultsSelector)
          els.forEach((result) => {
            if (!results.includes(result)) {
              results.push(result)
            }
          })
        }
      })
    })
    if (results.length > 0) {
      addDataLayerPushForElementVisible(results)
    }
  })
  const body = document.querySelector('body')
  if (!body) {
    return
  }
  observer.observe(body, { childList: true, subtree: true, attributes: false, characterData: false })

  dataLayer.pushOnCustomEvent(window.coreGtmId, document.body, 'sidePanelAccommodation.modal.opened', function (data, _el, domEvent) {
    if (!(domEvent instanceof CustomEvent) || domEvent.detail === null || typeof domEvent.detail !== 'object') {
      return false
    }

    const accommodationId = parseInt((domEvent.detail as { accommodationId: string }).accommodationId, 10)
    const accommodation = (data.accommodations as accommodations)[accommodationId]
    if (!accommodation) {
      return false
    }
    const eventData = {
      event: dataLayer.events.PRODUCT_SELECT_ACCOMMODATION,
      item_list_name: data.searchType,
    }
    Object.assign(eventData, accommodation)
    if (data.offers && (data.offers as offers)[accommodationId]) {
      Object.assign(eventData, (data.offers as offers)[accommodationId])
    }

    return eventData
  })

  dataLayer.pushOnCustomEvent(window.coreGtmId, document.body, 'checkOfferForm.submit', function (data, _el, domEvent) {
    if (!(domEvent instanceof CustomEvent) || domEvent.detail === null || typeof domEvent.detail !== 'object') {
      return false
    }

    const domEventDetail = domEvent.detail as { accommodationId: string; flexible?: { selected: boolean; amount: number } }

    const accommodationId = parseInt(domEventDetail.accommodationId, 10)
    const accommodation = (data.accommodations as accommodations)[accommodationId]
    if (!accommodation) {
      return false
    }
    const eventData = {
      event: dataLayer.events.PRODUCT_BEGIN_CHECKOUT,
    }
    Object.assign(eventData, data.product)
    Object.assign(eventData, accommodation)
    if (data.offers && (data.offers as offers)[accommodationId]) {
      Object.assign(eventData, (data.offers as offers)[accommodationId])
    }

    let serviceData = {
      service_relax_plus: false,
      service_total_amount: 0,
    }
    if (domEventDetail.flexible) {
      serviceData = {
        service_relax_plus: domEventDetail.flexible.selected,
        service_total_amount: domEventDetail.flexible.amount,
      }
    }

    Object.assign(eventData, {
      service_data: serviceData,
    })

    return eventData
  })

  if (document.querySelector('.product__errors [data="check_offer_error"]')) {
    dataLayer.pushInLayer(window.coreGtmId, { event: dataLayer.events.OLD_PRODUCT_CHECK_OFFER, MessageCheckOffer: 'Failure' })
  }
}

function addDataLayerPushForElementVisible(elements: NodeListOf<Element> | Element[]): void {
  dataLayer.pushOnElementVisible(window.coreGtmId, elements, (data, els) => {
    const accommodations: object[] = []
    els.forEach((el) => {
      const accommodationId = Number(el.getAttribute('data-id'))
      const accommodation = (data.accommodations as accommodations)[accommodationId]
      if (accommodation) {
        const accommodationData = {}
        const accommodationKey = Object.keys(accommodation)[0]
        if (accommodationKey !== undefined) {
          Object.assign(accommodationData, accommodation[accommodationKey]) // data are nested, we extract just data, ignore key
        }
        if (data.offers && (data.offers as offers)[accommodationId]) {
          const offer = (data.offers as offers)[accommodationId]
          if (offer) {
            const offerKey = Object.keys(offer)[0]
            if (offerKey !== undefined) {
              Object.assign(accommodationData, offer[offerKey]) // data are nested, we extract just data, ignore key
            }
          }
        }
        accommodations.push(accommodationData)
      }
    })
    if (!accommodations.length) {
      return false
    }

    return {
      event: dataLayer.events.PRODUCT_VIEW_ACCOMMODATIONS,
      item_list_name: data.searchType,
      accommodations,
    }
  })
}
